import { cn } from '@/app/lib';

export function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="skeleton" className={cn('bg-secondary-200 animate-pulse rounded-md', className)} {...props} />;
}
